/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

function handleInitialAdjustments({
  questionnaire,
  setFieldValue,
  personData,
  setShowBorrowerInfoSection
}) {
  try {
    const personPartyTypeAnswerOption = questionnaire.find((question) => question.idQuestion === 1891)?.idAnswerOption;

    if (personPartyTypeAnswerOption === 7559) {
      setShowBorrowerInfoSection(true);
    }

    return questionnaire.map(question => {
      if (question.idQuestion === 1956 && personPartyTypeAnswerOption === 7559) {
        const relationships = personData.personRelationships || [];
        const brokerRelationship = relationships["290"] && relationships["290"].find((relation) => relation.idPersonHead === personData.idPerson);

        if (brokerRelationship) {
          const brokerInfo = JSON.stringify({ value: brokerRelationship.personTailLastName, id: brokerRelationship.idPersonTail });

          question.answer = brokerInfo;
          question.answerJson = brokerInfo;
          setFieldValue && setFieldValue(question.key, brokerRelationship.idPersonTail);
        }
      }

      return question;
    });
  } catch (e) {
    console.log("BORROWER_INFO - handleInitialAdjustments error", e)
  }
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    let saveFilteredQuestionnaire = false;

    if (saveFilteredQuestionnaire) setQuestionnaire(questionnaireUpdated);
  } catch (e) {
    console.log("BORROWER_INFO - handleQuestionChange error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
  } catch (e) {
    console.log('BORROWER_INFO - handleRequestSerproCnpj error', e)
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleRequestSerproCnpj,
}

export { events };